import React, { Component } from 'react';
import TextField from 'material-ui/TextField';

import { Container, Row, Col } from '../BootstrapGrid';
import firebase from '../firebase';

class HistoryEntryController extends Component {
  state = {
    artwork: null,
  }

  componentDidMount() {
    if (!this.props.historyItem) {
      return;
    }

    this.artworkRef = firebase.database().ref().child('artwork').child(this.props.historyItem.value.artwork);
    this.artworkListener = this.artworkRef.on('value',
      (snapshot) => {
        this.setState({artwork: snapshot.val()});
      }
    );
  }

  render() {
    if (this.state.artwork && (this.props.showSkips || (this.props.historyItem.value.choice === "Like"))) {
      return <HistoryEntry historyItem={this.props.historyItem} artwork={this.state.artwork} />
    } else {
      return null;
    }
  }
}

function HistoryEntry(props) {
  return (
    <div>
      <img alt="artwork" src={props.artwork.image_urls[0]} style={{
          maxWidth:'90%',
          maxHeight:'300px',
          width: 'auto',
          height: 'auto',
          boxShadow: "1px 1px 2px #888888",
          margin: "10px auto",
        }}></img>
      <div style={{fontSize: "20px"}}>{props.artwork.title}</div>
      <div>{props.historyItem.value.choice === "Like" ? 'liked' : 'skipped' }</div>
      <div>
        <TextField
          name={props.historyItem.ref.key}
          value={props.historyItem.value.comment || ""}
          floatingLabelText={"What do you " + (props.historyItem.value.choice === "Like" ? "like" : "dislike") + "?"}
        />
      </div>
    </div>
  );
}


class ArtworkSideBySideAdminPage extends Component {

  state = {
    historyItems: [],
  }

  componentDidMount() {
    var userId = this.props.location.params.userId;
    this.historyRef = firebase.database().ref()
      .child('users').child(userId).child('tastemaker/history');

      // TODO: this is a copy-paste from TastemakerPage.js. Merge into a single library
      this.historyRef.on('child_added', snap => {
          const historyItem = {
              key: snap.key,
              ref: snap.ref,
              value: snap.val()
          };
          this.setState(previousState => {
              previousState.historyItems.push(historyItem);
              return { historyItems: previousState.historyItems };
          });
      });
      this.historyRef.on('child_changed', snap => {
        const newHistoryItem = {
            key: snap.key,
            ref: snap.ref,
            value: snap.val()
        };

        var change_item = function(historyItems, newHistoryItem) {
          for (var i=0; i<historyItems.length; i++) {
            if (historyItems[i].key === snap.key) {
              historyItems.splice(i, 1, newHistoryItem);
              return historyItems;
            }
          }
        };

        this.setState(previousState => {
          var newHistoryItems = change_item(previousState.historyItems, newHistoryItem);
          return { historyItems: newHistoryItems };
        });
      });
      this.historyRef.on('child_removed', snap => {
        function remove_item(historyItems, key) {
          for (var i=0; i<historyItems.length; i++) {
            if (historyItems[i].key === key) {
              historyItems.splice(i, 1);
              return historyItems
            }
          }
        }
          this.setState(previousState => {
            var newHistoryItems = remove_item(previousState.historyItems, snap.key);
            return { historyItems: newHistoryItems };
          });
      });
  }


  componentWillUnmount() {
    if (this.historyListenerRef != null) {
      this.historyListenerRef.off();
    }
  }

  render() {
    return (
      <div>

        <h1>user {this.props.location.params.userId}</h1>
        <Container>
          <Row>
            {this.state.historyItems.map((historyItem) =>

              <Col key={historyItem.key} cols={4}>
                <HistoryEntryController historyItem={historyItem} showSkips={false} />
              </Col>
            )}
          </Row>
        </Container>
      </div>
    );
  }
}

export default ArtworkSideBySideAdminPage;



// WEBPACK FOOTER //
// ./src/admin/TastemakerAdminPage.js